import revive_payload_client_4sVQNw7RlN from "/home/node/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/node/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/node/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import components_plugin_KR1HBZs4kY from "/home/node/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/node/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/home/node/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import dayjs_pGiXRjcsJO from "/home/node/plugins/dayjs.ts";
import i18n_VfGcjrvSkj from "/home/node/plugins/i18n.ts";
import iadea_control_cK6GYXMVRu from "/home/node/plugins/iadea-control.ts";
import vuetify_7h9QAQEssH from "/home/node/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  dayjs_pGiXRjcsJO,
  i18n_VfGcjrvSkj,
  iadea_control_cK6GYXMVRu,
  vuetify_7h9QAQEssH
]